export default {
	//关闭网页
	closePage() {
		var userAgent = navigator.userAgent;
		if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") != -1) {
			window.open('', '_self').close()
		} else {
			window.opener = null;
			window.open("about:blank", "_self");
			window.close();
		}
	},
	//创建a标签，用于下载，访问
	createA(url, filename) {
		const link = document.createElement('a');
		// link.target = '_blank' //如果该值为‘_self'该行可忽略
		link.target = '_self' //如果该值为‘_self'该行可忽略
		link.style.display = 'none';
		link.href = url;//所下载文件的网络地址
		link.download = filename;//下载成功后保存的文件名
		document.body.appendChild(link);
		link.click();
		link.remove();
	}

}
